import { combineReducers } from 'redux'
import app from './app/reducer'
import auth from './auth/reducer'
import user_session from './user_session/reducer'
import organizationSetting from './organizationSetting/reducer'
import sidebar from './sidebar/reducer'
import programs from './programs/reducer'
import cart from './cart/reducer'

const rootReducer = combineReducers({
  app,
  auth,
  user_session,
  cart,
  organizationSetting,
  sidebar,
  programs,
})

export type GlobalState = ReturnType<typeof rootReducer>

export default rootReducer
